import React from "react"
import PropTypes from "prop-types"
import styles from "./LinkButton.module.scss"
import Icon from "../icon/index"
import { cn } from "../../lib/helpers"
import { Link } from "gatsby"

const LinkButton = ({
  to,
  href,
  target,
  icon,
  children,
  inline,
  className,
}) => {
  return href ? (
    <a
      href={href}
      target={target}
      rel={target === "_blank" ? "noopener" : ""}
      className={cn(styles.link, inline && styles.inlineLink, className)}
    >
      {icon && <Icon symbol={icon} />}
      <span className={styles.textWrapper}>{children}</span>
    </a>
  ) : (
    <Link
      to={to}
      className={cn(styles.link, inline && styles.inlineLink, className)}
    >
      {icon && <Icon symbol={icon} />}
      <span className={styles.textWrapper}>{children}</span>
    </Link>
  )
}

LinkButton.propTypes = {
  href: PropTypes.string,
  target: PropTypes.oneOf(["_blank"]),
  icon: PropTypes.string,
  children: PropTypes.any.isRequired,
}

export default LinkButton
